export const BLOG_ARTICLE_CDN_BASE =
  'https://resources.getcartwheel.com/share/demo-videos/';
